import React, { useState, useRef, useEffect } from 'react';
import { FaTimes, FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const DomainCard = ({ hostname, details, onDelete, pools, handlePoolAction }) => {
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const dropdownRef = useRef(null);
    const sliceNum = 30;

    // Filter out null values from the pools array
    const filteredPools = (details?.pools || []).filter(pool => pool !== null);
    const availablePools = (pools || []).filter(pool => !filteredPools.includes(pool));

    const toggleDropdown = () => {
        setDropdownVisible(prev => !prev); // Toggle dropdown visibility
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownVisible(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="border-b overflow-visible relative justify-between overflow-hidden w-full px-3 pb-3 bg-white flex flex-col">
            {/* Header Section */}
            <div className="flex justify-between items-center w-full">
                <h2 className="text-xl font-semibold text-gray-800">
                    {hostname.length > sliceNum ? `${hostname.slice(0, sliceNum)}..` : hostname}
                </h2>

                {/* Delete Button */}
                <button
                    className="h-5 w-5 flex justify-center items-center bg-gray-500 hover:bg-red-600 text-white rounded-full"
                    aria-label="Delete domain"
                    onClick={() => onDelete(hostname)}
                >
                    <FaTimes className="w-3 h-3" />
                </button>
            </div>

            {/* Pools Section */}
            <div className="mt-2 flex flex-wrap items-center gap-2">
                {filteredPools.length === 0 ? (
                    <p className="text-sm text-gray-600">No pools</p>
                ) : (
                    filteredPools.map((pool, index) => (
                        <div key={index} className="flex gap-2 text-sm text-white font-semibold hover:bg-blue-600 bg-blue-500 rounded-full px-3 py-1">
                            <Link to={`/pool/${pool}`}>{pool}</Link>
                            <button
                                onClick={() => handlePoolAction(hostname, pool, false)}
                                className="flex flex-row items-center"
                            >
                                <FaTimes className="h-3 hover:h-4" />
                            </button>
                        </div>
                    ))
                )}

                {/* Add Pool Button */}
                <div className="relative" ref={dropdownRef}>
                    <button
                        className="h-5 w-5 flex justify-center items-center bg-gray-500 hover:bg-green-600 text-white rounded-full"
                        aria-label="Add pool"
                        onClick={toggleDropdown} // Toggle dropdown on click
                    >
                        <FaPlus className="w-3 h-3" />
                    </button>

                    {/* Dropdown Menu */}
                    {dropdownVisible && (
                        <div className="absolute left-0 mt-2 w-40 bg-white border rounded shadow-lg z-10">
                            <ul className="p-2">
                                {availablePools.map((pool, index) => (
                                    <li key={index}>
                                        <button
                                            className="block w-full text-sm text-gray-800 hover:bg-gray-200 p-1"
                                            onClick={() => {
                                                handlePoolAction(hostname, pool, true);
                                                setDropdownVisible(false); // Close the dropdown after selecting a pool
                                            }}
                                        >
                                            {pool}
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DomainCard;
